import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { signin } from '../slice/userSlice';
import { useNavigate } from 'react-router-dom';
import logo from '../asserts/logo.png';
import './Login.css';
import { FaEnvelope, FaLock, FaSignInAlt, FaEye, FaEyeSlash } from 'react-icons/fa';
import { MdAdminPanelSettings } from 'react-icons/md';

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [focusedField, setFocusedField] = useState('');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading, error, response, message } = useSelector((state) => state.user);

  useEffect(() => {
    if (response && response?.access_token && response?.user?.role === 'admin') {
      localStorage.setItem('token', response.access_token);
      localStorage.setItem('admin_last_activity', Date.now().toString());
      if (rememberMe) {
        localStorage.setItem('userToken', response.access_token);
      } else {
        sessionStorage.setItem('userToken', response.access_token);
      }
      navigate('/dashboard');
    } else if (error) {
      toast(message || 'Something went wrong');
    }
  }, [response, error, navigate, message, rememberMe, dispatch]);

  const loginHandler = async (e) => {
    e.preventDefault();
    dispatch(signin({ email: username, password }));
  };

  return (
    <div className="login-page">

      {/* Background Ambient Blobs */}
      <div className="login-blob login-blob-1"></div>
      <div className="login-blob login-blob-2"></div>

      <div className="login-card-container">
        
        {/* Top Logo */}
        <div className="lc-logo-wrap">
          <img src={logo} alt="Students Union Logo" className="lc-logo" />
        </div>

        {/* Header */}
        <div className="lc-header">
          <div className="lc-admin-badge">
            <MdAdminPanelSettings size={18} />
            <span>Admin Access</span>
          </div>
          <h1 className="lc-title">Welcome Back!</h1>
          <p className="lc-subtitle">Sign in to your admin account</p>
        </div>

        {/* Form */}
        <form onSubmit={loginHandler} className="lc-form">

          {/* Email / Username Field */}
          <div className={`lc-field-wrap ${focusedField === 'email' ? 'focused' : ''} ${username ? 'filled' : ''}`}>
            <label className="lc-label" htmlFor="login-email">Email Address</label>
            <div className="lc-input-wrap">
              <FaEnvelope className="lc-input-icon" />
              <input
                id="login-email"
                type="email"
                className="lc-input"
                placeholder="joyelpaul22@gmail.com"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                onFocus={() => setFocusedField('email')}
                onBlur={() => setFocusedField('')}
                required
              />
            </div>
          </div>

          {/* Password Field */}
          <div className={`lc-field-wrap ${focusedField === 'password' ? 'focused' : ''} ${password ? 'filled' : ''}`}>
            <label className="lc-label" htmlFor="login-password">Password</label>
            <div className="lc-input-wrap">
              <FaLock className="lc-input-icon" />
              <input
                id="login-password"
                type={showPassword ? 'text' : 'password'}
                className="lc-input"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onFocus={() => setFocusedField('password')}
                onBlur={() => setFocusedField('')}
                required
              />
              <button
                type="button"
                className="lc-eye-btn"
                onClick={() => setShowPassword(!showPassword)}
                tabIndex={-1}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
          </div>

          {/* Options (Remember Me) */}
          <div className="lc-options">
            <label className="lc-checkbox-wrap">
              <input
                type="checkbox"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
                className="lc-checkbox"
                id="rememberMe"
              />
              <span className="lc-checkmark"></span>
              <span className="lc-check-label">Remember Me</span>
            </label>
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            className="lc-submit-btn"
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="lc-spinner"></span>
                <span>Signing In...</span>
              </>
            ) : (
              <>
                <FaSignInAlt />
                <span>Sign In to Dashboard</span>
              </>
            )}
          </button>

        </form>

        <div className="lc-footer">
          <span>© 2026 Students Union AU &nbsp;·&nbsp; Admin Portal</span>
        </div>

      </div>
    </div>
  );
}

export default Login;
